
import { useEffect, useState } from "react";
import { useAuthState } from "../../../../../Helper/Context/context";
import { useDispatch, useSelector } from "react-redux";
import { Loading } from "../../../../../Helper/LogoLoader/LogoLoader";
import KeepingplantsAdd from "../KeepingplantsAdd/KeepingplantsAdd";
import DeletePopUP from "../../../../CommonPopUp/DeletePopUp";
import { KeepingPlantsDeleteAPI } from "../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartTwoSlice";
import { CommonCircle } from "../CommonCircle";
import { AstricSign } from "../../../../../Helper/AstricSign";


const KeepingPlantsAtHome = (props) => {

    const { YearValue, MonthValue, M_BeneficiaryDetailsID, KeepingQualityHomeData, DataIsPost, setDataIsPost, RadioKeepingplants, setRadioKeepingplants } = props

    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const dispatch = useDispatch()

    const [KeepingplantsPopup, setKeepingplantsPopup] = useState(false)

    const [ShowDeletePopup, setShowDeletePopup] = useState(false)
    const [ShowDeletePopupData, setShowDeletePopupData] = useState({
        data: ''
    })

    const handleAddKeepingplants = () => {
        setKeepingplantsPopup(!KeepingplantsPopup)
    }

    const handleShowDelete = (data) => {

        setShowDeletePopup(!ShowDeletePopup)
        { data && setShowDeletePopupData(data) }
    }
    const handleDataIsPost = () => {
        setDataIsPost(!DataIsPost)
        handleShowDelete()
        setShowDeletePopup(false)

    }

    const handleDeleteData = () => {
        // console.log("ShowDeletePopupData?.keepingPlantAtHome_M_IndicatorID",ShowDeletePopupData?.keepingPlantAtHome_M_IndicatorID)
        const data = {
            T_BeneficiaryPlantationDetails_KeepingPlanAtHomeID: ShowDeletePopupData?.t_BeneficiaryPlantationDetails_KeepingPlanAtHomeID,
            M_TableUserMasterID: UserID,
            token: token,
            handleDataIsPost
        }
        dispatch(KeepingPlantsDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.KeepingPlantsDeleteData)

    return (
        <>
            {isDeleteLoading && <Loading />}
            <div className="col-12 col-lg-10 mx-auto pt-3 pb-2 border-bottom">
                <CommonCircle />
                <span className="">
                    Keeping plants at home? <AstricSign /> :
                </span>

                <span className="px-3">
                    <input type="radio" onChange={() => setRadioKeepingplants('53')} id='53' name={RadioKeepingplants == 53} value="53" checked={RadioKeepingplants == 53 && "checked"} />
                    <label for="huey">Yes</label>

                </span>
                <span>
                    <input type="radio" onChange={() => setRadioKeepingplants('54')} id='54' name={RadioKeepingplants == 54} value="54" checked={RadioKeepingplants == 54 && "checked"} />
                    <label for="dewey">No</label>
                </span>
                {
                    RadioKeepingplants == 53 &&
                    <span className=" add_button mx-3 px-3 py-1"
                        onClick={() => handleAddKeepingplants()}
                    >
                        <i class="fa-solid fa-plus"></i>  Add
                    </span>
                }




                {
                    RadioKeepingplants == '53' ?

                        <div className="table-responsive p-0" >
                            <table className="table table-bordered">
                                <thead>
                                    <tr className=" text-white">
                                        {/* <th className="text-center">Sr. No.</th> */}
                                        <th className="text-center">Keeping plants at home</th>
                                        <th className="text-center">Action</th>


                                    </tr>
                                </thead>
                                <tbody>

                                    {

                                        KeepingQualityHomeData && KeepingQualityHomeData.length > 0 ? KeepingQualityHomeData.map((i, j) => {
                                            return (
                                                <>
                                                    {
                                                        i.isCheck == 1 ?
                                                            <tr>
                                                                {/* <td align="center">{j + 1}</td> */}
                                                                <td>{i.keepingPlantAtHome_M_IndicatorName ? i.keepingPlantAtHome_M_IndicatorName : '-'}</td>
                                                                <td align="center">

                                                                    <i className="fa fa-trash mx-2 text-danger v_icon_style"
                                                                        onClick={() => handleShowDelete(i)}
                                                                        title="Do you want to delete this record?"></i>
                                                                </td>

                                                            </tr>
                                                            :
                                                            <></>
                                                    }
                                                </>

                                            )
                                        })
                                            :
                                            <>No data found</>
                                    }

                                </tbody>
                            </table>

                        </div>
                        :
                        ''
                }

            </div>

            {
                KeepingplantsPopup &&
                <KeepingplantsAdd
                    handleAddKeepingplants={handleAddKeepingplants}
                    Title='Keeping plants at home'
                    M_BeneficiaryDetailsID={M_BeneficiaryDetailsID}
                    DataIsPost={DataIsPost}
                    setDataIsPost={setDataIsPost}
                    YearValue={YearValue}
                    MonthValue={MonthValue}


                />
            }
            {
                ShowDeletePopup ?
                    <DeletePopUP
                        handleShowDelete={handleShowDelete}
                        ShowDeletePopupData={ShowDeletePopupData}
                        handleDeleteData={handleDeleteData}

                    /> : <></>
            }


        </>
    );
}

export default KeepingPlantsAtHome;